/**
 * D4 合规降级命中收窄(2026-07-29)。
 *
 * 合规降级会把区块文案里的风险词换成降级词(「全国第一」→「全国领先」)。审计一直有 ——
 * ai 写 `assetMeta.compliance`、api 也落 `xb_detail_long_block.gen_json` —— 但一路没往上冒,
 * 用户拿到被改过词的成图,不知道是谁改的、改了哪几处。分段面板据此回显。
 *
 * 后端把 assetMeta 里那份**原样透出**,形状不保证(老任务没这个键、配置写坏时可能是别的东西)
 * —— 面板宁可不显示也不能因为一条脏数据白屏,所以消费端一律经这里收窄,不直接当数组用。
 */
export interface ComplianceHit {
  raw: string;
  safe: string;
}

export function complianceHits(raw: unknown): ComplianceHit[] {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((h) => {
    if (!h || typeof h !== "object") return [];
    const { raw: r, safe: s } = h as { raw?: unknown; safe?: unknown };
    if (typeof r !== "string" || typeof s !== "string" || !r.trim() || !s.trim()) return [];
    return [{ raw: r, safe: s }];
  });
}
